import axios from "axios";
import { config } from "@/profiles/profile.js";
import { keycloakInstance } from "@/plugins/authentication";

// Métodos gerais para tratamento de erros
function tratarStatusCode(err) {
	let mensagem = `<div> ERRO ${err?.response?.status}</div>`;

	if (err?.response?.data && typeof (err.response.data) === "string") {
		mensagem += err.response.data;
	}
	else if (err?.response?.status != 500 && err?.response?.data?.length > 0) {
		const listaMsgErro = err.response.data.filter((i) => i.mensagem);

		listaMsgErro.forEach((m) => {
			mensagem += `<li>${m.mensagem}</li>`;
		});
		// Caso do corpo da resposta ser vazio
	}
	else {
		mensagem += "Ocorreu algum erro no servidor.";
	}
	return mensagem;
}

const api = axios.create({});

// eslint-disable-next-line consistent-return
api.interceptors.request.use((configRequest) => new Promise((resolve, reject) => {
	configRequest.useCredentials = true;
	configRequest.headers["Access-Control-Allow-Origin"] = "*";
	configRequest.headers["Access-Control-Allow-Methods"] = "GET,POST,PATCH,PUT,DELETE,OPTIONS";
	configRequest.headers["Access-Control-Allow-Credentials"] = true;
	if (configRequest?.params?.noAuth === true) {
		return resolve(configRequest);
	}
	if (!keycloakInstance.authenticated) {
		if (keycloakInstance?.token) {
			configRequest.headers.Authorization = `Bearer ${keycloakInstance.token}`;
		}
		// eslint-disable-next-line no-promise-executor-return
		return resolve(configRequest);
	}
	keycloakInstance.updateToken(60)
		.then(() => {
			configRequest.headers.Authorization = `Bearer ${keycloakInstance.token}`;
			return resolve(configRequest);
		})
		// eslint-disable-next-line consistent-return
		.catch((err) => {
			console.error(err);
			if (keycloakInstance != null) {
				redirectLogin();
			}
			else {
				return reject(err);
			}
		});
}), (error) => {
	return Promise.reject(error);
});

api.defaults.baseURL = config.apis.urls.API_FGTAS;
// Resposta bem sucedida
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response) {
			// Foi feita uma requisição com o servidor respondendo com um status code
			tratarStatusCode(error);
		}
		else if (error.request) {
			// Foi feita uma requisição mas sem resposta do servidor
			// tratarSemRespostaServidor();
		}
		else {
			// Algum outro erro aconteceu
			// tratarOutrosErros();
		}

		return Promise.reject(error);
	},
);

export const URLS = config.apis.urls;
export default api;
